import { Season } from '@/models/Season';
import { Component, Prop } from 'vue-property-decorator';
import AbstractFilterMultipleModel from '@/components/CustomFilter/AbstractFilterMultipleModel';
import { FilterInterface } from '@/components/CustomFilter/FilterInterface';

@Component<SeasonFilter>({})
export default class SeasonFilter extends AbstractFilterMultipleModel implements FilterInterface {

  // #region @Props

  @Prop({ default: 'season' })
  protected filterStorageKey!: string;

  @Prop({ default: 'purchase_order_filters' })
  protected filtersStorageKey!: string;

  @Prop({
    default: () => new Season()
      .limit(100)
      .sort('name', 'ASC')
  })
  protected model!: Season;

  @Prop({ default: 'Seizoenen' })
  protected namePlural!: string;

  @Prop({ default: 'Zoek naar Seizoen' })
  protected placeholderSearch!: string;

  // #endregion
}
